import { render } from "./gallery.vue?vue&type=template&id=63648f45"
import script from "./gallery.js?vue&type=script&lang=js"
export * from "./gallery.js?vue&type=script&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=63648f45&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__